import capitalizeFirstLetter from './capitalize-first-letter';

export function formatOperatorName(email: string): string {
  if (!email || !email.includes('@')) {
    return email;
  }

  // Extrai o nome antes do @
  const namePart = email.split('@')[0];
  
  // Remove pontos e converte para array de palavras
  const words = namePart.split('.');
  
  // Capitaliza cada palavra e junta com espaço
  const formattedName = words
    .filter(word => word.length > 0) // Remove palavras vazias
    .map(word => capitalizeFirstLetter(word))
    .join(' ');

  return formattedName || email; // Fallback para o email original
}
